import type { GetIssueAssessmentByParentIdQuery } from '@/generated/graphql';
import { Parent_Type_Enum } from '@/generated/graphql';

export const getAssociatedControlIds = (
  data: GetIssueAssessmentByParentIdQuery | undefined
) =>
  data?.issue_parent
    .filter((i) => i.parent?.ObjectType === Parent_Type_Enum.Control)
    .map((i) => i.ParentId) ?? [];
